import LocalStorageService from "../LocalStorageService";

const RolesHelper = {
  help_determine_via_role: (isOrganization) => {
    // If passed from Redux, use that (secure)
    if (isOrganization !== undefined) {
      return Boolean(isOrganization);
    }
    // Fallback to localStorage (backward compatibility)
    const authData = LocalStorageService?.get("authorizationData");
    return Boolean(authData?.is_organization) || false;
  },
};

export default RolesHelper;
